// tienda/PreciosSection.jsx

import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { brand, fadeUp } from "../shared/brand";

const PLANS = [
  { label: "1 envío", price: "S/ 15", sub: "Para entregas puntuales en Lima", popular: false },
  { label: "2+ envíos / día", price: "S/ 9.90", sub: "Tienda estándar same-day", popular: true },
  { label: "Provider", price: "S/ 8.90", sub: "Fulfillment + envíos nacionales", popular: false },
];

export function PreciosSection() {
  return (
    <section id="precios" className="border-b scroll-mt-16" style={{ background: brand.bg, borderColor: brand.line }}>
      <div className="mx-auto max-w-7xl px-4 py-14 md:py-20">
        <motion.div {...fadeUp} className="mx-auto mb-10 max-w-2xl text-center">
          <p className="mb-3 text-xs font-black uppercase tracking-[0.2em]" style={{ color: brand.primary }}>
            Tarifas
          </p>
          <h2 className="text-3xl font-black md:text-4xl" style={{ color: brand.ink }}>
            Precios simples para calcular tu margen antes de vender.
          </h2>
          <p className="mt-4 text-sm leading-relaxed" style={{ color: brand.muted }}>
            Same-day en Lima y Callao. Para provincias, preparamos desde almacén y despachamos
            con Olva o Shalom según destino.
          </p>
        </motion.div>

        <div className="mx-auto grid max-w-4xl gap-4 md:grid-cols-3">
          {PLANS.map((plan, index) => (
            <motion.div
              key={plan.label}
              {...fadeUp}
              transition={{ ...fadeUp.transition, delay: index * 0.06 }}
              className="relative overflow-hidden rounded-2xl border bg-white p-6 text-center shadow-sm"
              style={{
                borderColor: plan.popular ? brand.primary : brand.line,
                boxShadow: plan.popular ? `0 24px 60px ${brand.primary}1F` : undefined,
              }}
            >
              {plan.popular && (
                <div className="absolute inset-x-0 top-0 h-1.5" style={{ background: `linear-gradient(90deg, ${brand.primary}, ${brand.accentGold})` }} />
              )}
              <div className="text-sm font-black" style={{ color: brand.ink }}>{plan.label}</div>
              <div className="mt-3 text-4xl font-black" style={{ color: brand.primary }}>{plan.price}</div>
              <div className="mt-1 text-xs font-semibold" style={{ color: brand.muted }}>{plan.sub}</div>
              <Link
                to="/register"
                className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-xl py-3 text-sm font-black text-white"
                style={{ background: plan.popular ? brand.primary : brand.plum }}
              >
                Crear cuenta
                <ArrowRight className="size-4" />
              </Link>
            </motion.div>
          ))}
        </div>

        <p className="mt-6 text-center text-xs" style={{ color: brand.muted }}>
          Tarifas base para Lima y Callao. Envíos nacionales dependen del destino y operador logístico.
        </p>
      </div>
    </section>
  );
}
